import React, { Component } from 'react';
import Validator from 'validatorjs';
import { withRouter } from 'react-router';
import * as QueryString from 'query-string';
import { Button, Form } from 'react-bootstrap';

import { Http } from '../../../support';
import { FormControl } from '../../../facturotopia';
import BussinesRulesForm from './BussinesRulesForm';
import DecimalAmount from '../../../support/DecimalAmount';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import TicketRequestSearchDownload from './TicketRequestSearchDownload';

class TimbradoTicketRequestSearch extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
      data: {
        tickets: {},
        ticketsCount: 0,
      },
    };
  }

  get rules() {
    const { data: bussines_control = [] } = this.props;

    let newRules = {};

    bussines_control.forEach(function (elemento, indice, array) {
      newRules = {
        ...newRules,
        [elemento.name]: elemento.rules,
      };
    });

    const rules = {
      codigo: ['required', 'max:255'],
      total: ['required', 'decimal:6'],
    };

    return {
      ...rules,
      ...newRules,
    };
  }

  componentDidMount() {
    this.handleOnChange({});
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (values, isValidBussinesRules = null) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  };

  handleOnAction = () => {
    this.setState({
      error: undefined,
      data: {},
      result: undefined,
      isValid: false,
    });
  };

  submit = async () => {
    const { data } = this.state;
    const params = QueryString.parse(this.props.location.search);

    const headers = {
      'X-Tenancy': params.tenancy,
    };
    this.setState({
      busy: true,
    });

    try {
      const response = await Http.get('api/autofacturacion/tickets/search', {
        params: {
          codigo: data.codigo,
          total: data.total,
          ...data,
          ...params,
        },
        headers,
      });

      if (response.status === 200) {
        const info = response.data;

        const result = {
          ...this.state.result,
          result: info,
        };

        this.setState({
          busy: false,
          result,
        });
      } else {
        const info = response.data;

        const tickets = {
          ...this.state.data.tickets,
          [info.id]: info,
        };

        this.setState({
          busy: false,
          data: {
            tickets,
            ticketsCount: Object.keys(tickets).length,
          },
        });

        this.next();
      }
    } catch (error) {
      this.setState({
        busy: false,
        error: error.data || error,
      });
    }
  };

  getSummary = () => {
    const { tickets, ticketsCount } = this.state.data;

    let total = 0;

    for (const item of Object.values(tickets)) {
      total += parseFloat(item.total);
    }

    return (
      <div className="pt-1">
        Tickets: {ticketsCount}
        <br />
        Total: {DecimalAmount.make(total).toString(2)}
      </div>
    );
  };

  next = () => {
    const tickets = Object.values(this.state.data.tickets);
    let conceptos = [];
    let data = {
      ...tickets[0].input,
    };

    for (const item of tickets) {
      const { input } = item;

      conceptos = conceptos.concat(input.Conceptos.Concepto);
    }

    data.Conceptos = {
      Concepto: conceptos,
    };

    /**
     * TODO
     * Corregir para soportar multiples tickets
     */
    // data = new ComprobanteImpuestosCalculator(data).withImpuestosGlobales().withTotales().get();

    data = {
      tickets: Object.keys(this.state.data.tickets),
      ...tickets[0].input,
    };

    this.props.onSearchSuccess(data);
  };

  render() {
    const { busy, data, error, result, isValid } = this.state;
    const { ticketsCount } = data;
    const { data: bussines_control = [] } = this.props;

    return (
      <Form autoComplete="off" translate="no">
        <FormControl
          name="codigo"
          label="Código / Nota de venta"
          autoFocus={true}
          value={data.codigo}
          rules={this.rules.codigo}
          onChange={this.handleOnChange}
        />

        <FormControl
          name="total"
          label="Total"
          value={data.total}
          rules={this.rules.total}
          onChange={this.handleOnChange}
        />

        {bussines_control.map((item) => (
          <BussinesRulesForm
            key={item.name}
            data={this.state.data}
            item={item}
            rules={this.rules}
            onChange={this.handleOnChange}
          />
        ))}

        {!!result && (
          <TicketRequestSearchDownload
            result={this.state.result}
            onChangeDownloadSucces={this.handleOnAction}
          />
        )}

        {!!error && (
          <ResponseError
            title="Error"
            error={error}
            onAction={this.handleOnAction}
          />
        )}

        <LoadingButton
          type="button"
          className="mr-1"
          disabled={!isValid}
          loading={busy || false}
          onClick={this.submit}
        >
          {busy === true ? 'Buscando...' : 'Buscar'}
        </LoadingButton>

        {ticketsCount > 0 && this.getSummary()}

        <div className="py-1"></div>

        {ticketsCount > 0 && (
          <Button
            type="button"
            onClick={this.next}
          >
            Continuar
          </Button>
        )}
      </Form>
    );
  }
}

export default withRouter(TimbradoTicketRequestSearch);
